import React, { forwardRef, ReactNode } from 'react'
import CustomIcons from '../../../../ui_reusable/CustomIcons'
import theme from '../../../../../styles/theme'
// Import AIPlusBadge from its new location
import AIPlusBadge from '../../../../ui_reusable/AIPlusBadge'
import {
  Container,
  HeaderContainer,
  TitleContainer,
  Title,
  Overview,
  ButtonContainer,
  IconButton,
  Divider,
  ContentContainer,
} from './styles/AIReportSubSection.styles'

interface AIReportSubSectionProps {
  title: string
  overviewText?: string
  children: ReactNode
}

const AIReportSubSection = forwardRef<HTMLDivElement, AIReportSubSectionProps>(
  ({ title, overviewText, children }, ref) => {
    return (
      <Container ref={ref}>
        <HeaderContainer>
          <TitleContainer>
            <AIPlusBadge>AI +</AIPlusBadge>
            <Title>{title}</Title>
            {overviewText && <Overview>{overviewText}</Overview>}
          </TitleContainer>
          <ButtonContainer>
            <IconButton>
              <CustomIcons.CirclePlusThickIcon
                size="small"
                color={theme.colors.fancyText}
              />
            </IconButton>
            <IconButton>
              <CustomIcons.ShareThickIcon
                size="small"
                color={theme.colors.fancyText}
              />
            </IconButton>
          </ButtonContainer>
        </HeaderContainer>
        <Divider />
        <ContentContainer>{children}</ContentContainer>
      </Container>
    )
  },
)

AIReportSubSection.displayName = 'AIReportSubSection'

export default AIReportSubSection
